// Shared UI kit (src/components/ui/**). Keep these generic — no page-specific wording.
const ui = {
  close: "Close",
  cancel: "Cancel",
  confirm: "Confirm",
  save: "Save",
  saving: "Saving…",
  saved: "Saved.",
  loading: "Loading…",
  working: "Working…",
  typeToConfirm: "Type <b>{text}</b> to confirm",
  somethingWentWrong: "Something went wrong. Please try again.",
  notAvailable: "Not available",
  source: "Source: {source}",
  breadcrumb: "Breadcrumb",
  sectionNavigation: "Section navigation",
  pagination: {
    label: "Pagination",
    summary: "Page {page} of {pages} · {total} total",
    previous: "Previous",
    next: "Next",
  },
  status: {
    IDEA: "Idea",
    BRIEF: "Brief",
    DRAFT: "Draft",
    REVIEW: "In review",
    SCHEDULED: "Scheduled",
    PUBLISHED: "Published",
    ARCHIVED: "Archived",
    UPDATE_REQUIRED: "Update required",
    CREATING: "Being built",
    UNPUBLISHED: "Offline",
    SUSPENDED: "Suspended",
    QUEUED: "Queued",
    RUNNING: "Running",
    WAITING_EXTERNAL: "Waiting on service",
    AWAITING_APPROVAL: "Needs approval",
    COMPLETED: "Completed",
    PARTIAL: "Partly completed",
    FAILED: "Failed",
    CANCELLED: "Cancelled",
    PENDING: "Pending",
    APPROVED: "Approved",
    REJECTED: "Rejected",
    PENDING_VERIFICATION: "Awaiting DNS",
    VERIFIED: "Verified · HTTPS pending",
    ACTIVE: "Active",
    DISCONNECTED: "Disconnected",
    UNCHECKED: "Not checked",
    OK: "OK",
    REDIRECTED: "Redirects",
    BROKEN: "Broken",
    ERROR: "Error",
    NOT_APPLIED: "Not applied",
    APPLIED: "Applied",
    PAUSED: "Paused",
  },
  severity: {
    error: "Error",
    warning: "Warning",
    info: "Info",
    notice: "Notice",
  },
  evidence: {
    confirmed: "Confirmed",
    inferred: "Inferred",
  },
};
export default ui;
